module.exports = __webpack_public_path__ + "img/loader.f89ce638.gif";